import { Store } from 'pullstate'

export const MemberStore = new Store({
  isShouldUpdateMemberLog: false,
  isMemberListLoading: false,
  memberList: [],
  memberPage: 1,
  memberTotal: 0
})
